import {
    put, takeLatest, call
} from 'redux-saga/effects';
import { authenticatedAxios } from '../client';
import {
    READY, readyFailure, readySuccess
} from "../actions/ready";

function* handleReady(action) {
    try {
        const response = yield call(authenticatedAxios.get, `${window.react_giftya_base_url}/ajax/ready`);
        yield put(readySuccess(response.data));
    } catch (e) {
        yield put(readyFailure());
    }
}
export function* watchReady() {
    yield takeLatest(READY, handleReady);
}